'use es6';

import { ACTIVE_CURRENCY_CODE_UPDATED } from 'pricing-pages-unified-ui/constants/ActionTypes';
import { countrySelector } from 'pricing-pages-unified-ui/selectors/CountrySelectors';
import { getCountry } from 'self-service-api/api/getCountry';
import CountryToCurrency from 'self-service-api/constants/CountryToCurrency';
import { createRequestTypes, createRequestActions } from './RequestActions';
export const FetchCountryRequestTypes = createRequestTypes('COUNTRY');
export const FetchCountryActions = createRequestActions(FetchCountryRequestTypes);
export const fetchCountry = () => {
  return (dispatch, getState) => {
    if (countrySelector(getState()) !== null) {
      return Promise.resolve().then(() => {
        return {
          country: countrySelector(getState())
        };
      });
    }

    dispatch(FetchCountryActions.request());
    return getCountry().then(resp => {
      const country = resp.country ? resp.country.toLowerCase() : null;
      dispatch(FetchCountryActions.receive({
        country
      }));
      const currency = CountryToCurrency[country];

      if (currency) {
        dispatch({
          type: ACTIVE_CURRENCY_CODE_UPDATED,
          payload: {
            currency
          }
        });
      } // Return for public promotions which chains to this call


      return {
        country
      };
    }).catch(error => {
      dispatch(FetchCountryActions.failure(error));
      throw error;
    });
  };
};